module.exports = __webpack_public_path__ + "brandon_reg-webfont.f10e940910df2a213e5a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_reg-webfont.woff2
// module id = 948
// module chunks = 7